import { publicPaths } from "@/routing";
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useToggle } from "react-use";
import { ILoggedProps } from "./types";

export const Logged: FunctionComponent<ILoggedProps> = observer(
  (props: ILoggedProps): ReactElement<ILoggedProps> => {
    const { children } = props;
    const store = useStore();
    const location = useLocation();
    const navigate = useNavigate();
    const [enabled, enable] = useToggle(false);

    useEffect((): void => {
      const hideContent = (): void => enable(false);
      authCheck(location.pathname);
    }, [location]);

    const authCheck = (url: string): void => {
      const path = url.split("?")[0];

      if (publicPaths.includes(path)) {
        enable(true);

        return;
      }

      if (!store.app.logged) {
        enable(false);

        navigate("/login", {
          state: {
            returnUrl: url,
          },
        });

        return;
      }

      enable(true);
    };

    return <>{enabled && children}</>;
  }
);
